import { useCrispIdentitySync } from "@hey-lady/shared/hooks/useCrispIdentitySync";
import React, { type ReactNode } from "react";

interface Props {
  children: JSX.Element | JSX.Element[] | ReactNode | ReactNode[];
}

/**
 * Mounts `useCrispIdentitySync` so the Crisp chatbox receives the logged-in
 * member's verified email (and resets on logout). Rendered inside the Apollo
 * provider context in `Router`.
 */
const CrispIdentitySyncWrapper: React.FC<Props> = ({ children }: Props) => {
  useCrispIdentitySync();

  return children;
};

export default CrispIdentitySyncWrapper;
